// extracted by mini-css-extract-plugin
export default {"card":"BadgeCard_card__mARoX","section":"BadgeCard_section__aeESk","like":"BadgeCard_like__oieEf","label":"BadgeCard_label__+Yhr2"};